import { ReactNode, useCallback } from 'react';
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
  useSearchParams,
  useParams
} from 'react-router';

type LinkProps = ReactRouterLinkProps & {
  children?: ReactNode;
  forwardKeys?: string[];
};

export default function Link({
  children,
  to,
  forwardKeys = ['days_ago'],
  ...rest
}: LinkProps) {
  const [searchParams] = useSearchParams();
  const { network } = useParams();

  const constructToPath = useCallback(() => {
    const path = (typeof to === 'object' ? to.pathname : to) as string;
    const isLocalPath = path.startsWith('/');
    const pathIsRoot = path === '/';

    const toPath = pathIsRoot
      ? `/${network}`
      : isLocalPath
        ? `/${network}${path}`
        : `${location.pathname}/${path}`;

    if (forwardKeys && forwardKeys.length > 0) {
      const toHasQueryParams = toPath.includes('?');

      const params = forwardKeys.map((key) =>
        searchParams.get(key) ? `${key}=${searchParams.get(key)}` : null
      );

      const prefix = toHasQueryParams ? '&' : '?';
      const search = params.join('&') ? `${prefix}${params.join('&')}` : '';

      return typeof to === 'object'
        ? { ...to, search: search }
        : `${toPath}${search}`;
    }
    return to;
  }, [forwardKeys, to, searchParams, network]);

  return (
    <ReactRouterLink {...rest} to={constructToPath()}>
      {children}
    </ReactRouterLink>
  );
}
